import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { Logo } from "../assets/logo/Logo";
import { User, Menu } from 'lucide-react';
import useAuthStore from '../store/authStore';
import ProfileHeaderstyle from '../assets/stylesheets/ProfileHeader.module.css';
import SignInButton from "../components/auth/SignInButton";

export default function ProfileHeader() {
  const navigate = useNavigate();
  const { user, logout } = useAuth0();
  const { role, clearAuth } = useAuthStore();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  
  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };
    
    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  const handleLogout = () => {
    clearAuth();
    localStorage.removeItem('ACCESS_TOKEN'); // Clear token
    logout({ returnTo: window.location.origin });
  };

  return (
    <header className={ProfileHeaderstyle["profile-header"]}>
      <div className={ProfileHeaderstyle["profile-header-container"]}>
        {/* Left Section: Logo */}
        <div className={ProfileHeaderstyle["logo-container"]}>
          <a href="/" className={ProfileHeaderstyle["logo-link"]}>
            <Logo
              className={ProfileHeaderstyle["logo"]}
              aria-label="Farmciti Logo"
            />
          </a>
        </div>

        {/* Right Section: Blog + Menu */}
        <div className={ProfileHeaderstyle["right-section"]}>

          <div className={ProfileHeaderstyle["blog-container"]}>
                <div className={ProfileHeaderstyle["blog-main"]}>
                    <Link to="/blog">
                        <button>Blog</button>
                    </Link>
                </div>
            </div>

            <div className={ProfileHeaderstyle["auth-container"]}>
                <SignInButton />
            </div>
        </div>
      </div>
    </header>
  );
}
